module.exports = __webpack_public_path__ + "static2024-7-11/img/yc.3648f9df.png";